import { ID } from '@datorama/akita';
import {RelationConfig} from '../../models/relation-config.model';

export interface Work {
  id: ID;
  name: string;
  employee: string;
  start_date: string;
  salary: string;
  thirteenth_month: boolean;
  holiday_pay: boolean;
  contract: RelationConfig;
  person_id: number;
  type: string;

  income_1_year_ago: number;
  income_2_years_ago: number;
  income_3_years_ago: number;

  contract_configuration_id?: number;
}

export function createWork(params: Partial<Work>) {
  return {

  } as Work;
}
